// SPDX-License-Identifier: AGPL-3.0-or-later
import {msg} from '@lingui/core/macro';
import type {SectionDefinition} from './SectionRegistryTypes';

export const assistantSections = [
	{
		id: 'assistant-connectors',
		tabType: 'konvo_assistant',
		label: msg`Assistant connections`,
		keywords: ['GitHub', 'custom connector', 'API', 'OAuth', 'tokens', 'connectors', 'staff'],
		isAdvanced: false,
	},
	{
		id: 'assistant-flows',
		tabType: 'konvo_assistant',
		label: msg`Schedules and automations`,
		keywords: ['schedule', 'scheduled messages', 'automations', 'flows', 'recurring', 'approvals'],
		isAdvanced: false,
	},
	{
		id: 'assistant-reports',
		tabType: 'konvo_assistant',
		label: msg`Reports`,
		keywords: ['reports', 'export', 'download', 'CSV'],
		isAdvanced: false,
	},
	{
		id: 'assistant-dashboards',
		tabType: 'konvo_assistant',
		label: msg`Dashboards`,
		keywords: ['dashboards', 'charts', 'graphs', 'pinned', 'saved', 'Home'],
		isAdvanced: false,
	},
	{
		id: 'konvo-knows',
		tabType: 'assistant_knows',
		label: msg({
			message: 'What Konvo knows',
			comment: 'User settings tab (under Assistant) listing what the Konvo assistant remembers about the user.',
		}),
		keywords: ['memory', 'remember', 'notes', 'forget', 'profile', 'summary', 'learned', 'VIP', 'history', 'privacy'],
		isAdvanced: false,
	},
	{
		id: 'konvo-assistant-voice-mode',
		tabType: 'konvo_assistant',
		label: msg`Voice mode position`,
		keywords: ['voice mode', 'globe', 'centred', 'centered', 'Ask', 'corner assistant', 'position', 'talk'],
		isAdvanced: false,
	},
	{
		id: 'konvo-assistant-memory',
		tabType: 'konvo_assistant',
		label: msg({
			message: 'What it remembers',
			comment: 'Assistant settings section that links to the What Konvo knows page.',
		}),
		keywords: ['memory', 'remember', 'notes', 'what Konvo knows', 'forget'],
		isAdvanced: false,
	},
] as const satisfies ReadonlyArray<SectionDefinition>;
